import {useContext} from "react";
import {FrameworkContext, FrameworkAgnosticComponents} from "./FrameworkProvider";

/**
 * Hook that supplies frame-agnostic components such as "Link" to be used across @bettorsignals/ui package.
 */
export function useFramework(): FrameworkAgnosticComponents {
    return useContext<FrameworkAgnosticComponents>(FrameworkContext);
}
